<template>
  <div class="screening-progress-and-results">
    <stage-card-progress-bar
      title="Screened"
      success-tooltip-prefix="Screened:"
      :success-count="screenedCount"
      light-success-tooltip-prefix="Partially Screened:"
      :light-success-count="partiallyScreenedCount"
      error-tooltip-prefix="Conflicted:"
      :error-count="conflictedCount"
      other-tooltip-prefix="Unscreened:"
      :total-count="totalCount"
    />
    <screening-results-pills
      :outcome-summary="review.screeningOutcomeSummary"
    />
  </div>
</template>

<script>
import StageCardProgressBar from './StageCardProgressBar';
import ScreeningResultsPills from './ScreeningResultsPills';
import { Review } from '@/models';

export default {
  name: 'ScreeningProgressAndResults',
  components: { StageCardProgressBar, ScreeningResultsPills },
  props: {
    review: {
      type: Review,
      required: true,
    },
  },
  computed: {
    screenedCount() {
      return this.screeningProgressSummary?.screenedCount ?? 0;
    },
    partiallyScreenedCount() {
      return (
        this.screeningProgressSummary?.partiallyScreenedCount ?? 0
      );
    },
    conflictedCount() {
      return (
        this.screeningProgressSummary?.conflictedScreenCount ?? 0
      );
    },
    totalCount() {
      return (
        this.screeningProgressSummary?.totalReferenceCount() ?? 0
      );
    },
    screeningProgressSummary() {
      return this.review.screeningProgressSummary ?? {};
    },
  },
};
</script>

<style lang="scss" scoped>
.screening-progress-and-results {
  display: grid;
  gap: 14px;
}
</style>
